<div *ngIf="authService.getUsuario?.fk_nivel == 0 || authService.getUsuario?.fk_nivel == 1">
    <app-administrador-notificaciones-canje-enfermeras />
    <app-administrador-notificaciones-canje-medicos />
</div>